import React from 'react';
import { Button, Col, Row } from 'antd';
import { RightOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';
import CustomText from '../../../../atoms/CustomText';

function RodapeSimulador({
  onEmpresaClick,
  onEnviarEmailClick,
  onExportarArquivoClick,
}) {
  return (
    <Row gutter={[24, 24]} type="flex" justify="space-between">
      <Col>
        <Button type="link" onClick={onEmpresaClick}>
          <RightOutlined style={{ color: '#0b8af7' }} />
          <CustomText marginleft="8px" fontSize="12px" color="#0b8af7">
            Para empresa
          </CustomText>
        </Button>
      </Col>
      <Col
        style={{
          display: 'grid',
          gridAutoFlow: 'column',
          columnGap: 16,
          marginLeft: 'auto',
          justifyContent: 'flex-end',
          marginTop: '16px',
        }}
      >
        <Button type="primary" onClick={onEnviarEmailClick}>
          Enviar por e-mail
        </Button>
        <Button type="primary" onClick={onExportarArquivoClick}>
          Exportar Excel
        </Button>
      </Col>
    </Row>
  );
}

RodapeSimulador.propTypes = {
  onEmpresaClick: PropTypes.func.isRequired,
  onEnviarEmailClick: PropTypes.func.isRequired,
  onExportarArquivoClick: PropTypes.func.isRequired,
};

export default RodapeSimulador;
